import {Campaign} from '../../libs/types/src';
import {formatCampaignErrorMessage} from '../../libs/ui/src/utils/functions/formatErrorMessages';
import {getCampaignCompletionState} from '../../libs/ui/src/utils/functions/getCampaignCompletionState';

export function hydrateCampaignDerivedState(campaign: Campaign) {
  const nextCampaign = {...campaign};
  const {completionErrorCode} = getCampaignCompletionState(nextCampaign);

  if (!nextCampaign.error_code && !nextCampaign.warning_code && completionErrorCode) {
    nextCampaign.error_code = completionErrorCode;
  }

  if (nextCampaign.error_code) {
    nextCampaign.error = formatCampaignErrorMessage(nextCampaign.error_code, nextCampaign);
  }

  return nextCampaign;
}

export function shouldSyncCampaignCompletionError(previousCampaign: Campaign | undefined, nextCampaign: Campaign) {
  const {completionErrorCode} = getCampaignCompletionState(nextCampaign);

  return Boolean(
    completionErrorCode &&
      nextCampaign.error_code === completionErrorCode &&
      !previousCampaign?.error_code &&
      !previousCampaign?.warning_code
  );
}
